export default "__VITE_ASSET__DnRni4Ju__"